<!-- 首页点击跳转到问卷调查页面 -->
<template>
  <div>
    <div class="questionnaire clearfix" id="questionnaireId">
      <van-list :immediate-check="false" v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div class="questionnaireDiv" v-for="item in questionnaire" :key="item.id"
          @click="gotoQuestionnaireDetail(item.id)">
          <img src="../../assets/image/btn_wenjuandiaocha_nor.png" alt="调查问卷" class="questionnaireImg" />
          <div class="questionnaireName">{{ item.name }}</div>
          <div class="questionnaireTime">
            {{ item.startTime }} ~ {{ item.endTime }}
          </div>
        </div>
      </van-list>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      questionnaire: [],
      loading: false,
      finished: false,
      lastPage: "",
      postData: {
        page: 1,
        pageSize: 8,
      }
    };
  },
  created() {
    this.getQuestionnaire();
  },
  methods: {
    async getQuestionnaire() {
      const result = await this.$http.get("/questionnaire/getMoreQuestionnaireList", {
        params: { currentPage: this.postData.page, perpage: this.postData.pageSize },
      });
      this.lastPage = result.data.lastPage;
      for (let i = 0; i < result.data.list.length; i++) {
        this.questionnaire.push(result.data.list[i]);
      }
    },
    // 懒加载
    onLoad() {
      this.postData.page = this.postData.page + 1;
      this.getQuestionnaire();
      this.loading = false;
      // 数据全部加载完成
      if (this.postData.page >= this.lastPage) {
        this.finished = true;
      }
    },
    gotoQuestionnaireDetail(id) {
      return this.$router.push({
        path: "/questionnaireDetail",
        query: { id: id },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.questionnaire {
  position: relative;
  left: 5%;
  width: 90vw;
}

.questionnaireDiv {
  margin-top: 10px;
  position: relative;
}

.questionnaireImg {
  width: 90vw;
}

.questionnaireName {
  position: absolute;
  left: 5%;
  top: 23%;
  font-size: 1.1rem;
  font-weight: bold;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  color: #000;
}

.questionnaireTime {
  position: absolute;
  left: 5%;
  top: 55%;
  width: 58%;
  font-size: 0.8em;
  color: #666666;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}
</style>



// WEBPACK FOOTER //
// src/components/questionnaire/QuestionnaireList.vue